<template lang="pug">
div
  v-row
    v-col(cols=12)
      v-row(dense, justify="center", align="start")
        v-col(cols=12)
          v-select(v-model="bubble.fuelType", :items="fuelOptions", attach)
      v-row(dense, justify="center", align="start")
        v-card.pa-2.ma-2(v-on:click="selectCarType(0)", :flat="carType != 0")
          v-img(
            src="https://powersell.appstack.me/icons/hybrid.svg",
            width="80",
            height="80",
            style="transform: scaleX(-1)",
            v-bind:class="{ white: $vuetify.theme.dark }"
          )
          span.button-label Hybrid
        v-card.pa-2.ma-2(v-on:click="selectCarType(1)", :flat="carType != 1")
          v-img(
            src="https://powersell.appstack.me/icons/compact.svg",
            width="80",
            height="80",
            v-bind:class="{ white: $vuetify.theme.dark }"
          )
          span.button-label Efficient
        v-card.pa-2.ma-2(v-on:click="selectCarType(2)", :flat="carType != 2")
          v-img(
            src="https://powersell.appstack.me/icons/standard_car.svg",
            width="80",
            height="80",
            v-bind:class="{ white: $vuetify.theme.dark }"
          )
          span.button-label Standard
        v-card.pa-2.ma-2(v-on:click="selectCarType(3)", :flat="carType != 3")
          v-img(
            src="https://powersell.appstack.me/icons/gas_guzzler.svg",
            width="80",
            height="80",
            v-bind:class="{ white: $vuetify.theme.dark }"
          )
          span.button-label Gas Guzzler

  v-row
    v-col
      div.text-h5.primary--text.font-weight-bold Can you charge at home?
      div.subtitle-2 Any socket that charges your phone can charge an EV! Could you charge at home, or would you use public charging?
  v-row.my-4(dense, justify="center", align="start")
    
      v-card.pa-2.ma-2(
        v-on:click="selectChargeAtPark(true)",
        :flat="!bubble.chargeAtPark"
      )
        v-img(
          src="https://powersell.appstack.me/icons/private_charging.svg",
          width="80",
          height="80",
          v-bind:class="{ white: $vuetify.theme.dark }"
        )
        span.button-label Yes, Private
      v-card.pa-2.ma-2(
        v-on:click="selectChargeAtPark(false)",
        :flat="bubble.chargeAtPark"
      )
        v-img(
          src="https://powersell.appstack.me/icons/public_charging.svg",
          width="80",
          height="80",
          v-bind:class="{ white: $vuetify.theme.dark }"
        )
        span.button-label No, Public
</template>

<script>
import HowThisWorks from "./HowThisWorks";
export default {
  components: { HowThisWorks },
  props: ["bubble", "settings"],
  data() {
    return {
      fuelOptions: ["Petrol", "Diesel"],
      carType: 2,
    };
  },
  methods: {
    selectCarType(index) {
      this.carType = index;
      console.log(
        this.$dealer.default_settings.default_settings.carTypes[index].petrolConsumption
      );
      this.settings.petrolConsumption = this.$dealer.default_settings.default_settings.carTypes[
        index
      ].petrolConsumption;
      this.settings.dieselConsumption = this.$dealer.default_settings.default_settings.carTypes[
        index
      ].dieselConsumption;
      console.log(this.settings);
    },
    selectChargeAtPark(val) {
      this.bubble.chargeAtPark = val;
    },
  },
  mounted() {
    this.selectCarType(this.carType);
  },
  computed: {
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
          return true;
        default:
          return false;
      }
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
}
.small {
  font-size: 0.9em;
}
.km-indicator {
  font-weight: bold;
}
.petrol-indicator,
.diesel-indicator {
  font-style: italic;
}
.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
}

.v-select__selection {
  width: 100%;
  justify-content: center;
}

.button-label {
  font-size: 0.8em;
  display: block;
  text-align: center;
  margin-top: -10px;
}
.white {
  filter: invert(1);
  mix-blend-mode: lighten;
}
</style>
